import { render } from "./App.vue?vue&type=template&id=4fb1ab58"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/flatly/bootstrap.min.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__